<template>
  <section v-on:click="sectionClicked">
    <Header ref="header" :class="{scrolled: scrolled}"/>
    <div class="loadingFull" v-if="loading"></div>
    <div class="notFoundCnt" v-else-if="!detail">
      <div class="notFound">
        <img src="../assets/not-found.png">
        <h4>404</h4>
        <h2>Halaman tidak ditemukan</h2>
        <p>We can't find the page you looking for</p>
        <button v-on:click="this.$router.push('/')"
          class="btn secondary">Back To Home</button>
      </div>
    </div>
    <div v-else>
      <div class="supportHeader" v-if="detail.headerMedia"
        :style="{'background-image': `url(${detail.headerMedia.imageLg})`}"></div>
      <div class="supportHeader noImg" v-else></div>
      <div class="cnt cntArticle">
        <div class="supportCnt">
          <div class="supportInfo">
            <h2>{{detail.title}}</h2>
            <div class="timestampCnt">
              <div class="category">Dukungan</div>
              <div class="timestamp">{{detail.publishDate | moment('dddd, DD MMMM YYYY')}}</div>
            </div>
            <div class="articleDetail supportPage" v-html="detail.content"></div>
          </div>
          <div class="supportForm" ref="supportForm">
            <div class="supportInfoContent" v-html="detail.info"></div>
            <div class="supporter" v-if="detail.target">
              <h4>{{detail.supporterCount.toLocaleString('id')}}
                / {{detail.target.toLocaleString('id')}}
                orang mendukung petisi ini</h4>
              <div class="progress">
                <div class="progressBar"
                  :style="{width: `${detail.supporterCount / detail.target * 100}%`}"></div>
              </div>
            </div>
            <div class="downloadCnt" v-if="detail.files && detail.files.length">
              <h5>Download</h5>
              <p>Silahkan isi form dukungan terlebih dahulu untuk mengunduh file ini</p>
              <div v-if="supported">
                <a :href="file.uri" target="_blank" class="download" download
                  v-for="(file, i) of detail.files" :key="`file${i}`"
                  v-on:click="recordDownload">
                  <h4>{{file.media.name}}</h4>
                  <p>Keterangan file jika ada</p>
                  <div class="icon"></div>
                </a>
              </div>
              <div v-else>
                <div class="download locked"
                  v-for="(file, i) of detail.files" :key="`file${i}`">
                  <h4>{{file.media.name}}</h4>
                  <p>Keterangan file jika ada</p>
                  <div class="icon"></div>
                </div>
              </div>
            </div>
            <div class="supported" v-if="supported">
              <div class="success-animation">
                <svg class="checkmark" xmlns="http://www.w3.org/2000/svg"
                  viewBox="0 0 52 52"><circle class="checkmark__circle"
                  cx="26" cy="26" r="25" fill="none" /><path class="checkmark__check"
                  fill="none" d="M14.1 27.2l7.1 7.2 16.7-16.8" /></svg>
              </div>
              <h4>Terima kasih</h4>
              <p>Terima kasih telah mendukung {{detail.title}}<span
                v-if="detail.files && detail.files.length">,
                kamu sekarang bisa download file</span></p>
            </div>
            <form v-else v-on:submit.prevent="supportNow">
              <div class="fieldCnt" v-for="(field, i) in detail.fields"
                :key="`field${i}`" :class="{hasError: field.error}">
                <label>{{field.label}} <span v-if="field.isRequired">*</span></label>
                <input :type="field.type" :placeholder="field.placeholder"
                  v-model="field.model" class="field" v-on:input="field.error = null"
                  v-if="field.type === 'text' || field.type === 'date'">
                <textarea class="field" v-model="field.model"
                  :placeholder="field.placeholder" rows="3"
                   v-on:input="field.error = null"
                  v-else-if="field.type === 'textarea'"></textarea>
                <select class="field" v-model="field.model"
                  :placeholder="field.placeholder"
                   v-on:change="field.error = null"
                  v-else-if="field.type === 'select'">
                  <option v-for="(o, i2) in field.options"
                    :key="`odd${i2}`">{{o.model}}</option>
                </select>
                <div class="checkWrapper" v-else-if="field.type === 'checkbox'">
                  <label v-for="(o, i2) in field.options" :key="`ock${i2}`"
                    class="fieldCk" v-on:click="field.error = null">
                    <input type="checkbox" v-model="o.checked"> {{o.model}}
                  </label>
                </div>
                <div class="fieldError" v-if="field.error">{{field.error}}</div>
              </div>
              <button class="btn primary" :class="{loading: btnLoading}">
                <span>Saya Dukung</span></button>
            </form>
          </div>
        </div>

        <div class="articleShareSpacer" :class="{hidden: shareHidden}"></div>
        <div class="articleShare" :style="{top: `${shareTop}px`}" :class="{hidden: shareHidden}">
          <h4>Share</h4>
          <div class="shareCnt">
            <a target="_balnk"
              :href="`https://www.facebook.com/sharer/sharer.php?u=${shareUri}`">
              <i class="fa fa-facebook fa-fw"></i>
            </a>
            <a target="_balnk"
              :href="`https://twitter.com/intent/tweet?text=${detail.title}&amp;url=${shareUri}`">
              <i class="fa fa-twitter fa-fw"></i>
            </a>
            <a :href="`whatsapp://send?text=${detail.title} ${shareUri}`">
              <i class="fa fa-whatsapp fa-fw"></i>
            </a>
            <a target="_balnk"
              :href="`https://telegram.me/share/url?url=${shareUri}&amp;text=${detail.title}`">
              <i class="fa fa-telegram fa-fw"></i>
            </a>
            <a :href="`mailto:?subject=${detail.title}&amp;body=Check this out:
              <a href='${shareUri}'>${detail.title}</a>`">
              <i class="fa fa-email fa-fw"></i>
            </a>
          </div>
        </div>
        <div ref="endArticle"></div>
        <div class="related">
          <div v-if="related.length > 0">
            <h4>Dukungan terkait</h4>
            <div class="relatedCnt">
              <div class="relatedSc">
                <a :href="`/dukungan/${item.code}`" class="relatedItem row3"
                  v-for="(item, i) in related" :key="`rlt${i}`">
                  <div class="relatedImg" v-if="item.headerMedia"
                    :style="{'background-image': `url(${item.headerMedia.imageSm})`}"></div>
                  <div class="relatedImg noImg" v-else></div>
                  <h4>{{item.title}}</h4>
                  <p>{{item.description}}</p>
                </a>
              </div>
            </div>
          </div>
          <div v-if="products.length > 0">
            <h4>Merchandise</h4>
            <div class="relatedCnt merchandise">
              <div class="relatedSc">
                <a class="relatedItem merchandise" v-for="(item, i) in products"
                  :key="`prd${i}`" :href="`/uncorupted/product/${item.code}`">
                  <div class="relatedImg" v-if="item.images.length > 0 && item.images[0].media"
                    :style="{'background-image': `url(${item.images[0].media.imageSm})`}">
                  </div>
                  <div class="relatedImg noImg" v-else></div>
                  <h4>{{item.name}}</h4>
                  <div class="priceCntRlt" v-if="item.discount">
                    <div class="priceDiscount">
                      Rp {{item.sellPrice.toLocaleString('id')}}
                    </div>
                    <div class="price">Rp {{item.discountedPrice.toLocaleString('id')}}</div>
                  </div>
                  <div class="priceCntRlt" v-else>
                    <div class="price">Rp {{item.sellPrice.toLocaleString('id')}}</div>
                  </div>
                  <button class="btn primary">Beli Sekarang</button>
                </a>
              </div>
            </div>
          </div>
          <div v-if="donations.length > 0">
            <h4>Donasi</h4>
            <div class="relatedCnt">
              <div class="relatedSc">
                <a class="relatedItem row3 donation" v-for="(item, i) in donations"
                  :key="i" :href="`/donasi/${item.code}`">
                  <div class="relatedImg" v-if="item.headerMedia"
                    :style="{'background-image': `url(${item.headerMedia.imageSm})`}"></div>
                  <div class="relatedImg noImg" v-else></div>
                  <h4>{{item.title}}</h4>
                  <p>{{item.description}}</p>
                  <button class="btn primary">Kirimkan Donasi</button>
                </a>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
import Header from '@/components/Header.vue';

export default {
  name: 'home',
  components: { Header },
  data() {
    return {
      loading: true,
      scrolled: false,
      supported: false,
      btnLoading: false,
      detail: null,
      submissionId: 0,
      form: {
        name: { model: '' },
        email: { model: '' },
        phone: { model: '' },
      },
      shareTop: null,
      shareHidden: false,
      shareUri: '',

      related: [],
      products: [],
      donations: [],
    };
  },
  methods: {
    doNothing() {},
    sectionClicked() {
      if (this.$refs.header) this.$refs.header.headerClicked();
    },
    docScrolled() {
      this.scrolled = (window.pageYOffset >= 30);
      const currentScrollPos = window.pageYOffset;
      const aHRect = this.$refs.endArticle.getBoundingClientRect();
      let stSpace = (60 + 96 + 140) - 96;
      if (window.innerWidth > 1480) {
        stSpace += 560;
      } else if (window.innerWidth > 1260) {
        stSpace += 500;
      } else {
        stSpace += 460;
      }
      if (aHRect.top > 420 && currentScrollPos >= stSpace) {
        this.shareTop = 100 + currentScrollPos;
      } else if (aHRect.top > 420) {
        this.shareTop = stSpace + 100;
      }
      this.shareHidden = (aHRect.top <= window.innerHeight);
    },
    recordDownload() {
      const uri = `support/submission/${this.submissionId}/record/download`;
      this.$http.get(this.$config.uri(uri)).then(() => {});
    },
    supportNow() {
      if (this.btnLoading) return;
      // eslint-disable-next-line
      for (const field of this.detail.fields) {
        if (field.isRequired && field.type === 'checkbox') {
          let hasCheck = false;
          // eslint-disable-next-line
          for (const o of field.options) {
            if (o.checked) hasCheck = true;
          }
          if (!hasCheck) {
            field.error = `Mohon isi ${field.label}`;
            return;
          }
        } else if (field.isRequired && !field.model) {
          field.error = `Mohon isi ${field.label}`;
          return;
        }
      }
      this.btnLoading = true;
      const uri = `support/${this.detail.id}/submit`;
      this.$http.post(this.$config.uri(uri), this.detail.fields).then((r) => {
        this.submissionId = (r.data.status === 200) ? r.data.id : 0;
        this.detail.supporterCount += 1;
        this.$refs.supportForm.scrollIntoView({
          behavior: 'smooth',
        });
        this.btnLoading = false;
        this.supported = true;
      });
    },
  },
  created() { document.addEventListener('scroll', this.docScrolled); },
  destroyed() { document.removeEventListener('scroll', this.docScrolled); },
  mounted() {
    const { code } = this.$route.params;
    this.$http.get(this.$config.uri(`support/${code}`)).then((r) => {
      this.loading = false;
      if (r.data.status !== 200) {
        // Display error
        return;
      }
      this.detail = r.data.data;
      this.shareUri = `${this.$config.appUri}dukungan/${this.detail.code}`;

      const rltUri = `support/all?related=${this.detail.id}&limit=3`;
      this.$http.get(this.$config.uri(rltUri)).then((rRlt) => {
        this.related = (rRlt.data.status === 200) ? rRlt.data.data : [];
      });
      this.$http.get(this.$config.uri('product/all?limit=4')).then((rPrd) => {
        this.products = (rPrd.data.status === 200) ? rPrd.data.data : [];
      });
      this.$http.get(this.$config.uri('donation/all?limit=3')).then((rDnt) => {
        this.donations = (rDnt.data.status === 200) ? rDnt.data.data : [];
      });
    });
  },
};
</script>

<style lang="scss">
.articleDetail.supportPage{
  p{
    margin: 0;
    line-height: 1.5;
    font-size: 18px;
  }
}
</style>

<style scoped lang="scss">
.cnt.cntArticle{
  max-width: 1200px;
  margin: 0 auto;
  @media (max-width: 1480px) {
    max-width: 1080px;
  }
  @media (max-width: 1260px) {
    max-width: none;
    margin: 0 30px;
  }
  @media (max-width: 960px) {
    margin: 0 20px;
  }
}
.articleShareSpacer{
  @media (max-width: 1260px) {
    height: 62px;
    &.hidden{
      height: 0;
    }
  }
}
.articleShare{
  position: absolute;
  // 560 header img, 96 header, 60 donation spacing
  top: calc(560px + 60px + 96px + 140px);
  left: calc(((100% - 1200px) / 2) - 80px);
  padding: 0 10px 5px;
  background-color: #fff;
  border-radius: 5px;
  @media (max-width: 1480px) {
    left: calc(((100% - 1080px) / 2) - 80px);
    top: calc(500px + 60px + 96px + 140px);
  }
  h4{
    margin: 0 0 10px;
    font-size: 12px;
    text-align: center;
    text-transform: uppercase;
    color: #767676;
  }
  a{
    display: block;
    .fa{
      width: 40px;
      height: 40px;
      display: block;
      border-radius: 50%;
      margin: 0 auto;
      margin-top: 4px;
      background-size: 26px auto;
      background-position: center;
      background-repeat: no-repeat;
      opacity: .5;
      &:hover{
        background-color: #fff;
        opacity: 1;
      }
    }
    .fa.fa-facebook{
      background-image: url(../assets/share-facebook.png);
    }
    .fa.fa-twitter{
      background-image: url(../assets/share-twitter.png);
    }
    .fa.fa-whatsapp{
      background-image: url(../assets/share-whatsapp.png);
    }
    .fa.fa-telegram{
      background-image: url(../assets/share-telegram.png);
    }
    .fa.fa-email{
      background-image: url(../assets/share-email.png);
    }
  }
  &.articleShareStatic{
    position: static;
    margin: 20px 0 0;
    padding: 10px 0;
    border: none;
    display: flex;
    align-items: center;
    @media (max-width: 680px) {
      margin-left: -4px;
    }
    h4{
      margin: 0 10px 0 0;
      @media (max-width: 680px) {
        display: none;
      }
    }
    .shareCnt{
      display: flex;
    }
  }
  @media (max-width: 1260px) {
    position: fixed;
    display: flex;
    left: 0; right: 0;
    top: auto !important; bottom: 0;
    background-color: #fff;
    transform: none;
    border-radius: 0;
    padding: 10px 30px;
    z-index: 991;
    border-top: #eee 1px solid;
    margin: 0;
    align-items: center;
    @media (max-width: 960px) {
      padding: 10px 20px;
    }
    &.hidden{
      position: static;
      border-bottom: #eee 1px solid;
      margin: 0 -30px;
      @media (max-width: 960px) {
        margin: 0 -20px;
      }
    }
    h4{
      text-align: left;
      margin: 0;
      margin-right: 20px;
      font-size: 17px;
      text-transform: none;
      @media (max-width: 680px) {
        display: none;
      }
    }
    .shareCnt{
      display: flex;
      a{
        margin: 0;
        margin-right: 10px;
        padding: 0;
        .fa{
          margin: 0;
        }
      }
    }
  }
  @media (max-width: 680px) {
    padding-left: 10px;
  }
}

.supportHeader{
  background-color: #ccc;
  background-position: center;
  background-size: cover;
  background-repeat: no-repeat;
  margin-top: 96px;
  height: 44vw;
  max-height: 580px;
  @media (max-width: 1020px) {
    height: 46vw;
  }
  @media (max-width: 980px) {
    height: 48vw;
  }
  @media (max-width: 680px) {
    height: 60vw;
  }
  &.noImg{
    background-image: url(../assets/image-black.png);
    background-size: 64px auto;
    opacity: .36;
  }
}
.supportCnt{
  display: flex;
  @media (max-width: 980px) {
    display: block;
    max-width: 600px;
    margin: 0 auto;
  }
  .supportInfo{
    width: calc(100% - 480px);
    box-sizing: border-box;
    padding: 40px 0;
    padding-right: 80px;
    @media (max-width: 1240px) {
      width: calc(100% - 440px);
    }
    @media (max-width: 1040px) {
      width: calc(100% - 400px);
    }
    @media (max-width: 980px) {
      width: auto;
      padding: 40px 0 20px;
    }
    @media (max-width: 680px) {
      padding: 30px 0 10px;
    }
    h2{
      margin: 0 0 20px -1px;
      font-size: 48px;
      line-height: 1.3;
      @media (max-width: 1480px) {
        font-size: 46px;
      }
      @media (max-width: 1280px) {
        font-size: 40px;
      }
      @media (max-width: 1040px) {
        font-size: 36px;
      }
      @media (max-width: 980px) {
        font-size: 32px;
        margin: 0 0 10px;
      }
      @media (max-width: 680px) {
        font-size: 26px;
      }
    }
    p{
      margin: 0 0 20px;
      font-size: 19px;
      line-height: 1.7;
    }
    .timestampCnt{
      display: flex;
      align-items: center;
      padding-bottom: 20px;
      font-size: 15px;
      color: #444;
      .category{
        background-color: #035fae;
        border-radius: 50px;
        color: #fff;
        font-weight: 600;
        font-size: 14px;
        padding: 6px 14px;
        margin-right: 16px;
      }
    }
  }
  .supportForm{
    border-left: #eee 1px solid;
    padding: 60px 0;
    padding-left: 60px;
    width: 480px;
    box-sizing: border-box;
    @media (max-width: 1240px) {
      width: 440px;
      padding-left: 40px;
    }
    @media (max-width: 1040px) {
      width: 400px;
      padding-left: 30px;
    }
    @media (max-width: 980px) {
      width: auto;
      padding-left: 0;
      border: none;
      padding-top: 0;
    }
    h4{
      margin: 0 0 16px;
      font-size: 20px;
      font-weight: 600;
    }
    p{
      margin: 0 0 20px;
      b{
        font-weight: 600;
      }
    }
    .downloadCnt{
      padding: 20px 0 0;
      h5{
        margin: 0;
        font-size: 16px;
        font-weight: 600;
      }
      p{
        margin: 0 0 10px;
        font-size: 14px;
        color: #767676;
        max-width: 360px;
      }
      .download{
        border: #eee 1px solid;
        box-shadow: 2px 2px 4px rgba(0, 0, 0, .1);
        padding: 10px 20px;
        margin-bottom: 10px;
        border-radius: 5px;
        position: relative;
        display: block;
        transition: all .3s ease;
        cursor: pointer;
        padding-right: 60px;
        .icon{
          width: 30px; height: 30px;
          position: absolute;
          right: 14px; top: 50%;
          margin-top: -15px;
          background-size: 24px auto;
          background-position: center;
          background-repeat: no-repeat;
          background-image: url(../assets/download-green.png);
        }
        &.locked{
          cursor: default;
          .icon{
            background-image: url(../assets/private.png);
            opacity: .65;
          }
        }
        h4{
          margin: 0;
          // margin: 0 0 2px;
          font-size: 16px;
          white-space: nowrap;
          overflow: hidden;
          text-overflow: ellipsis;
        }
        p{
          margin: 0;
          display: none;
        }
      }
    }
    .supporter{
      padding: 15px 20px 18px;
      background-color: #EEF3FF;
      border-radius: 3px;
      h4{
        font-size: 15px;
        margin: 0 0 10px;
      }
      .progress{
        background-color: #acb7d4;
        border-radius: 50px;
        height: 10px;
        .progressBar{
          background-color: #035fae;
          border-radius: 50px;
          height: 10px;
        }
      }
    }
    .supported{
      background-color: #f9e503;
      text-align: center;
      padding: 40px 20px;
      margin-top: 20px;
      border-radius: 5px;
      .success-animation{
        margin-bottom: 24px;
        .checkmark{
          width: 100px;
          height: 100px;
          border-radius: 50%;
          display: block;
          stroke-width: 2;
          stroke: #4bb71b;
          stroke-miterlimit: 10;
          box-shadow: inset 0px 0px 0px #4bb71b;
          animation: fill .4s ease-in-out .4s forwards, scale .3s ease-in-out .9s both;
          margin: 0 auto;
        }
        .checkmark__circle{
          stroke-dasharray: 166;
          stroke-dashoffset: 166;
          stroke-width: 2;
          stroke-miterlimit: 10;
          stroke: #4bb71b;
          fill: #f9e503;
          animation: stroke 0.6s cubic-bezier(0.65, 0, 0.45, 1) forwards;
        }
        .checkmark__check{
          transform-origin: 50% 50%;
          stroke-dasharray: 48;
          stroke-dashoffset: 48;
          animation: stroke 0.3s cubic-bezier(0.65, 0, 0.45, 1) 0.8s forwards;
        }
        @keyframes stroke {
          100% {
            stroke-dashoffset: 0;
          }
        }
        @keyframes scale {
          0%, 100% {
            transform: none;
          }
          50% {
            transform: scale3d(1.1, 1.1, 1);
          }
        }
        @keyframes fill {
          100% {
            box-shadow: inset 0px 0px 0px 30px #4bb71b;
          }
        }
      }
      h4{
        margin: 0 0 6px;
      }
    }
    form{
      padding-top: 20px;
      .fieldCnt{
        margin-bottom: 20px;
        label{
          display: block;
          font-weight: 500;
          font-size: 15px;
          margin: 0 0 6px;
        }
        .field{
          width: 100%;
          box-sizing: border-box;
          padding: 12px 10px;
          border-radius: 5px;
          font-size: 16px;
          border: #ccc 1px solid;
        }
        .fieldCk{
          cursor: pointer;
          padding: 4px 0;
          input{
            float: left;
            margin: 4px 12px 0 0;
          }
        }
        &.hasError{
          .field{
            border-color: red;
          }
        }
        .fieldError{
          color: red;
          font-size: 12px;
          margin: 4px 0 0 7px;
        }
      }
      .btn{
        width: 100%;
      }
    }
  }
}
</style>
